export class InsuranceCompany {
    id!: number;
    description?: string;
    status: boolean = true;
    isEdit: boolean = false;
  }